import React, { useCallback } from "react";
import { Grid2, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import DoneIcon from "@mui/icons-material/Done";
import Button from "@mui/material/Button";
import { useTranslate } from "../../../hooks/useTranslate";
import Preloader from "../../../components/Preloader";
import axiosManagerRegister from "../../../services/axiosManagerRegister";
import { useUpdateChild } from "../hooks/useUpdateChild";

export const TimezoneSelect = (props) => {
    const {
        registrationId, detailsData,
        divisionSelected, onDivisionChange, onPrev, onNext,
    } = props;
    const { t } = useTranslate();

    const {
        isFetching: isLoadingDivisions, data: divisions,
    } = useQuery({
        queryKey: ["add-student/divisions"],
        queryFn: () => axiosManagerRegister.get$("api/api/division").then((response) => response?.data),
        retry: 0,
    });

    const { updateChild, isUpdatingChild } = useUpdateChild();

    const convertTimeAMPM = useCallback((time) => {
        if (!time) return "";

        const ampm = +time.split(":")[0] >= 12 ? "pm" : "am";
        return time.replace(/.{3}$/, ampm);
    }, []);

    const onNextClick = async () => {
        try {
            await updateChild({ regId: registrationId, leadId: detailsData?.leadId, requestData: { ...detailsData, schoolDivisionId: divisionSelected } });

            onNext?.();
        } catch {
            // silently fails
        }
    };

    return (
        <div className="details-form">
            <Typography variant="h1">
                {t("addStudent.selectTimezone")}
            </Typography>
            <Typography variant="body1" component="div">
                {t("addStudent.selectTimezoneSub")}
            </Typography>
            <Preloader isLoading={isLoadingDivisions} size={40}>
                <div className="flex flex-wrap align-stretch gap-4 mt-4">
                    {(divisions || []).map((division) => (
                        <button
                            key={division.divisionId}
                            type="button"
                            className={`add-student-selection-option add-student-selection-option--division ${division.divisionId === divisionSelected ? "selected" : ""}`}
                            onClick={() => onDivisionChange(division.divisionId)}
                        >
                            <span className="add-student-selection-option__icon">
                                {division.divisionId === divisionSelected && <DoneIcon />}
                            </span>
                            <span className="add-student-selection-option__primary-text">{division.name}</span>
                            <span>{`${t("addStudent.lessons")} ${division.weekStartName} - ${division.weekEndName}`}</span>
                            <span>
                                {`${t("addStudent.starting")} ${convertTimeAMPM(
                                    division.startTime,
                                )} ${division.timeZoneDisplay}`}
                            </span>
                        </button>
                    ))}
                </div>
            </Preloader>
            <Typography variant="h5" className="mt-8">
                {t("addStudent.selectTimezoneNote")}
            </Typography>
            <div className="add-student__form-narrow flex align-center gap-8 mt-8">
                <Button
                    variant="outlined"
                    className="add-student-form__button"
                    onClick={onPrev}
                    disabled={isLoadingDivisions || isUpdatingChild}
                >
                    {t("button.back")}
                </Button>
                <Button
                    variant="contained"
                    className="button-accent add-student-form__button"
                    disabled={isLoadingDivisions || !divisionSelected}
                    loading={isUpdatingChild}
                    onClick={onNextClick}
                >
                    {t("button.next")}
                </Button>
            </div>
        </div>
    );
};
